import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'


import 'normalize.css'
import 'animate.css'

Vue.config.productionTip = false

const the360 = new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')

window.$ = window.jQuery = require('jquery');

var renderer = require('vue-server-renderer').createRenderer();

renderer.renderToString(the360).then(html => {
  console.log(html)
}).catch(err => {
  console.error(err)
})